import { Box, Typography } from "@mui/material";
import useColors from "../../../../../api/hooks/useColors";
import { ReactComponent as NotificationIcon } from "../../../environment/icons/sidebar_icons/sidebar-icons-notifications.svg";
import PotentialCollapsibleSection from "./PotentialCollapsibleSection";

export const NOTIFICATION_SECTION_CLASSNAME = "notification-section";

export default function NotificationSection({ displayName }) {
  const colors = useColors();
  return (
    <PotentialCollapsibleSection
      title="Notifications & Automation"
      Icon={NotificationIcon}
    >
      <div
        className={NOTIFICATION_SECTION_CLASSNAME}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          padding: "8px 0",
        }}
      >
        <Box display="flex" gap={1} flexDirection="column">
          <Typography variant="body2" color={colors.text_primary}>
            By connecting {displayName} to Breeze, security insights are
            delivered directly where teams work, boosting security awareness and
            team collaboration.
          </Typography>
        </Box>
      </div>
    </PotentialCollapsibleSection>
  );
}
